export default __webpack_public_path__ + "static/media/failed-dialog.f88e4b97.svg";